import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PrivateIcon from '@wix/da-ds/pkg/Icons/16x16/Private';
import useDeviationStats from '../useDeviationStats';
import Stat from '../Stat';
const PrivateCollectionStat = ({ deviation, onlyNumbers, className })=>{
    const { privatelyCollected } = useDeviationStats(deviation);
    const private_collections = useFlag('private_collections');
    if (!privatelyCollected || !private_collections) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Stat, {
        className: className,
        deviation: deviation,
        icon: PrivateIcon,
        statNameLocaleKey: "deviation.stats.privateCollections",
        statCount: privatelyCollected,
        onlyNumbers: onlyNumbers
    });
};
PrivateCollectionStat.displayName = 'PrivateCollectionStat';
export default PrivateCollectionStat;
